import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import LoadingSpinner from './shared/components/ui/LoadingSpinner';
import HowToonMain from './HowToonMain';
import { GAME_PATHS } from './features/games/gameRegistry';

const GamesHub             = React.lazy(() => import('./features/games'));
const GameSwipeLayout      = React.lazy(() => import('./features/games/GameSwipeLayout'));
const StockMarketBroadcast      = React.lazy(() => import('./features/games/stock-market/StockMarketBroadcast'));
const StudyBroadcastPage        = React.lazy(() => import('./features/study-broadcast/StudyBroadcastPage'));
const StudyMeetQuestionsPage    = React.lazy(() => import('./features/study-broadcast/StudyMeetQuestionsPage'));
const StudyMeetThumbnailEditor  = React.lazy(() => import('./features/study-broadcast/StudyMeetThumbnailEditor'));
const StudyMeetBannerEditor     = React.lazy(() => import('./features/study-broadcast/StudyMeetBannerEditor'));
const StudyMeetIconEditor       = React.lazy(() => import('./features/study-broadcast/StudyMeetIconEditor'));
const StudyApp                  = React.lazy(() => import('./features/study/StudyApp'));
const WordSearchBroadcastPage   = React.lazy(() => import('./features/word-search-broadcast/WordSearchBroadcastPage'));
const WordSearchThumbnail       = React.lazy(() => import('./features/word-search-broadcast/WordSearchThumbnail'));
const PomodoroTimer        = React.lazy(() => import('./features/tools/PomodoroTimer'));
const PrivacyPolicyPage    = React.lazy(() => import('./pages/PrivacyPolicyPage'));
const AboutPage            = React.lazy(() => import('./pages/AboutPage'));
const DousetsutoiPage      = React.lazy(() => import('./features/dousetsutoi/DousetsutoiPage'));

const GA_MEASUREMENT_ID = "G-SP519GQ0M2";
ReactGA.initialize(GA_MEASUREMENT_ID);

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
  return null;
};

const CanonicalUpdater = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const BASE = 'https://howtoon-official.com';
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = BASE + pathname;
  }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <CanonicalUpdater />
      <Suspense fallback={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <LoadingSpinner text="読み込んでいます..." />
        </div>
      }>
        <Routes>
          <Route path="/" element={<HowToonMain />} />
          <Route path="/games" element={<GamesHub />} />
          {GAME_PATHS.map(path => (
            <Route key={path} path={path} element={<GameSwipeLayout />} />
          ))}
          <Route path="/games/:gameId" element={<GamesHub />} />
          <Route path="/games/stock-market/broadcast" element={<StockMarketBroadcast />} />
          <Route path="/word-search/broadcast" element={<WordSearchBroadcastPage />} />
          <Route path="/word-search/thumbnail" element={<WordSearchThumbnail />} />
          <Route path="/study-broadcast" element={<StudyBroadcastPage />} />
          <Route path="/study-meet/broadcast" element={<StudyBroadcastPage />} />
          <Route path="/study-meet/questions" element={<StudyMeetQuestionsPage />} />
          <Route path="/study-meet/questions/:roomId" element={<StudyMeetQuestionsPage />} />
          <Route path="/study-meet/thumbnail" element={<StudyMeetThumbnailEditor />} />
          <Route path="/study-meet/banner" element={<StudyMeetBannerEditor />} />
          <Route path="/study-meet/icon" element={<StudyMeetIconEditor />} />
          <Route path="/tools/pomodoro" element={<PomodoroTimer />} />
          <Route path="/study" element={<StudyApp />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/dousetu" element={<DousetsutoiPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
